import { AssetTypeService } from './asset-type.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { ASSET_TYPE_TYPE, AssetType } from 'assets-model';
import { Observable } from 'rxjs';



@Injectable({ providedIn: 'root' })
export abstract class AssetTypeResolverBase implements Resolve<AssetType> {

  constructor(protected service: AssetTypeService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<AssetType> {
    const key: number = ASSET_TYPE_TYPE.entityDecorator.toKeyObjectFromRouteParams(route.params);
    return this.service.get(key);
  }
}



